var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCircleUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 21C5.25 23.0683 5.65739 25.1164 6.4489 27.0273C7.24041 28.9381 8.40055 30.6744 9.86307 32.1369C11.3256 33.5995 13.0619 34.7596 14.9727 35.5511C16.8836 36.3426 18.9317 36.75 21 36.75C23.0683 36.75 25.1164 36.3426 27.0273 35.5511C28.9381 34.7596 30.6744 33.5995 32.1369 32.1369C33.5995 30.6744 34.7596 28.9381 35.5511 27.0273C36.3426 25.1164 36.75 23.0683 36.75 21C36.75 18.9317 36.3426 16.8836 35.5511 14.9727C34.7596 13.0619 33.5995 11.3256 32.1369 9.86307C30.6744 8.40055 28.9381 7.24041 27.0273 6.4489C25.1164 5.65739 23.0683 5.25 21 5.25C18.9317 5.25 16.8836 5.65739 14.9727 6.4489C13.0619 7.24041 11.3256 8.40055 9.86307 9.86307C8.40055 11.3256 7.24041 13.0619 6.4489 14.9727C5.65739 16.8836 5.25 18.9317 5.25 21Z",
    stroke: "#23262F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 17.5C15.75 18.8924 16.3031 20.2277 17.2877 21.2123C18.2723 22.1969 19.6076 22.75 21 22.75C22.3924 22.75 23.7277 22.1969 24.7123 21.2123C25.6969 20.2277 26.25 18.8924 26.25 17.5C26.25 16.1076 25.6969 14.7723 24.7123 13.7877C23.7277 12.8031 22.3924 12.25 21 12.25C19.6076 12.25 18.2723 12.8031 17.2877 13.7877C16.3031 14.7723 15.75 16.1076 15.75 17.5Z",
    stroke: "#23262F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7939 32.9858C11.2271 31.5441 12.1134 30.2806 13.3214 29.3825C14.5294 28.4843 15.9947 27.9996 17.4999 28H24.4999C26.0071 27.9995 27.4743 28.4854 28.6831 29.3856C29.892 30.2858 30.778 31.5521 31.2094 32.9962",
    stroke: "#23262F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleUser);
export default __webpack_public_path__ + "static/media/circle-user.e9f531b0bffae49ba5686dc369372301.svg";
export { ForwardRef as ReactComponent };